import './UserSelect.scss'
import React, { useState, useContext } from 'react'
import API from 'misc/api'

import { OrganizationContext } from 'components/Contexts/OrganizationProvider'
import { clearToken } from 'misc/api/storedToken'
import UserSettingsModal from 'components/Modals/UserSettingsModal'
import { useTranslation } from 'react-i18next'
import { SETTINGS_MODAL_ENABLED } from '../../misc/api/util'

const LogoutIcon = () => (
  <svg
    fill="currentColor"
    width="18"
    height="17"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M4.934 2.916a1.25 1.25 0 0 1 0 1.768 5.75 5.75 0 1 0 8.132 0 1.25 1.25 0 1 1 1.768-1.768 8.25 8.25 0 1 1-11.668 0 1.25 1.25 0 0 1 1.768 0zM9 0c.647 0 1.18.492 1.244 1.122l.006.128v6a1.25 1.25 0 0 1-2.494.128L7.75 7.25v-6C7.75.56 8.31 0 9 0z" />
  </svg>
)

const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="14 14 16 16"
    fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2188 14.3828C22.9687 14.1276 22.6615 14 22.2969 14H21.7031C21.3385 14 21.0313 14.1276 20.7812 14.3828C20.5312 14.638 20.4062 14.9427 20.4062 15.2969C20.4062 15.4427 20.3646 15.5755 20.2812 15.6953C20.1979 15.8151 20.0885 15.8958 19.9531 15.9375C19.8177 15.9792 19.6849 16.0286 19.5547 16.0859L19.1562 16.2656C19.1146 16.2865 19.0703 16.3021 19.0234 16.3125C18.9766 16.3229 18.9271 16.3281 18.875 16.3281C18.7917 16.3281 18.7057 16.3125 18.6172 16.2812C18.5286 16.25 18.4531 16.1979 18.3906 16.125C18.2656 16 18.1224 15.9063 17.9609 15.8438C17.7995 15.7812 17.6354 15.75 17.4688 15.75C17.3021 15.75 17.1406 15.7812 16.9844 15.8438C16.8281 15.9063 16.6875 16 16.5625 16.125L16.125 16.5625C15.875 16.8125 15.75 17.1172 15.75 17.4766C15.75 17.8359 15.875 18.1406 16.125 18.3906C16.2292 18.4948 16.2943 18.6172 16.3203 18.7578C16.3464 18.8984 16.3281 19.0312 16.2656 19.1562C16.2031 19.2813 16.1458 19.4115 16.0938 19.5469L15.9375 19.9531C15.8958 20.0885 15.8151 20.1979 15.6953 20.2812C15.5755 20.3646 15.4427 20.4062 15.2969 20.4062C14.9427 20.4062 14.638 20.5312 14.3828 20.7812C14.1276 21.0313 14 21.3385 14 21.7031V22.2969C14 22.6615 14.1276 22.9687 14.3828 23.2188C14.638 23.4688 14.9427 23.5938 15.2969 23.5938C15.4427 23.5938 15.5755 23.6354 15.6953 23.7188C15.8151 23.8021 15.8958 23.9115 15.9375 24.0469C15.9792 24.1823 16.0286 24.3151 16.0859 24.4453L16.2656 24.8438C16.3281 24.9688 16.3464 25.1016 16.3203 25.2422C16.2943 25.3828 16.2292 25.5052 16.125 25.6094C15.875 25.8594 15.75 26.1641 15.75 26.5234C15.75 26.8828 15.875 27.1875 16.125 27.4375L16.5625 27.875C16.6875 28 16.8281 28.0938 16.9844 28.1562C17.1406 28.2188 17.3021 28.25 17.4688 28.25C17.6354 28.25 17.7995 28.2188 17.9609 28.1562C18.1224 28.0938 18.2656 28 18.3906 27.875C18.4531 27.8021 18.5286 27.75 18.6172 27.7188C18.7057 27.6875 18.7917 27.6719 18.875 27.6719C18.9271 27.6719 18.9766 27.6771 19.0234 27.6875C19.0703 27.6979 19.1146 27.7135 19.1562 27.7344C19.2813 27.7969 19.4115 27.8542 19.5469 27.9062L19.9531 28.0625C20.0885 28.1042 20.1979 28.1849 20.2812 28.3047C20.3646 28.4245 20.4062 28.5573 20.4062 28.7031C20.4062 29.0573 20.5312 29.362 20.7812 29.6172C21.0313 29.8724 21.3385 30 21.7031 30H22.2969C22.6615 30 22.9687 29.8724 23.2188 29.6172C23.4688 29.362 23.5938 29.0573 23.5938 28.7031C23.5938 28.5573 23.6354 28.4245 23.7188 28.3047C23.8021 28.1849 23.9115 28.1042 24.0469 28.0625C24.1823 28.0208 24.3151 27.9714 24.4453 27.9141L24.8438 27.7344C24.8854 27.7135 24.9297 27.6979 24.9766 27.6875C25.0234 27.6771 25.0729 27.6719 25.125 27.6719C25.2083 27.6719 25.2917 27.6875 25.375 27.7188C25.4583 27.75 25.5365 27.8021 25.6094 27.875L25.7065 27.9629C25.8071 28.0449 25.918 28.1094 26.0391 28.1562C26.2005 28.2188 26.3646 28.25 26.5312 28.25C26.6979 28.25 26.8594 28.2188 27.0156 28.1562C27.1719 28.0938 27.3125 28 27.4375 27.875L27.875 27.4375C28.125 27.1875 28.25 26.8828 28.25 26.5234C28.25 26.1641 28.125 25.8594 27.875 25.6094L27.8042 25.5278C27.7407 25.4429 27.6992 25.3477 27.6797 25.2422C27.6536 25.1016 27.6719 24.9688 27.7344 24.8438C27.7969 24.7187 27.8542 24.5885 27.9062 24.4531L28.0625 24.0469C28.1042 23.9115 28.1849 23.8021 28.3047 23.7188C28.4245 23.6354 28.5573 23.5938 28.7031 23.5938C29.0573 23.5938 29.362 23.4688 29.6172 23.2188C29.8724 22.9687 30 22.6615 30 22.2969V21.7031C30 21.3385 29.8724 21.0313 29.6172 20.7812C29.362 20.5312 29.0573 20.4062 28.7031 20.4062C28.5573 20.4062 28.4245 20.3646 28.3047 20.2812C28.1849 20.1979 28.1042 20.0885 28.0625 19.9531C28.0208 19.8177 27.9714 19.6849 27.9141 19.5547L27.7344 19.1562C27.6719 19.0312 27.6536 18.8984 27.6797 18.7578C27.7057 18.6172 27.7708 18.4948 27.875 18.3906L27.9745 18.2801C28.1582 18.0525 28.25 17.7846 28.25 17.4766C28.25 17.1172 28.125 16.8125 27.875 16.5625L27.4375 16.125C27.3125 16 27.1719 15.9063 27.0156 15.8438C26.8594 15.7812 26.6979 15.75 26.5312 15.75C26.3646 15.75 26.2005 15.7812 26.0391 15.8438C25.8776 15.9063 25.7344 16 25.6094 16.125C25.5469 16.1979 25.4714 16.25 25.3828 16.2812C25.2943 16.3125 25.2083 16.3281 25.125 16.3281C25.0729 16.3281 25.0234 16.3229 24.9766 16.3125C24.9297 16.3021 24.8854 16.2865 24.8438 16.2656C24.7187 16.2031 24.5885 16.1458 24.4531 16.0938L24.0469 15.9375C23.9115 15.8958 23.8021 15.8151 23.7188 15.6953C23.6354 15.5755 23.5938 15.4427 23.5938 15.2969C23.5938 14.9427 23.4688 14.638 23.2188 14.3828ZM23.7422 20.2578C23.2578 19.7734 22.6771 19.5312 22 19.5312C21.3229 19.5312 20.7422 19.7734 20.2578 20.2578C19.7734 20.7422 19.5312 21.3229 19.5312 22C19.5312 22.6771 19.7734 23.2578 20.2578 23.7422C20.7422 24.2266 21.3229 24.4688 22 24.4688C22.6771 24.4688 23.2578 24.2266 23.7422 23.7422C24.2266 23.2578 24.4688 22.6771 24.4688 22C24.4688 21.3229 24.2266 20.7422 23.7422 20.2578Z"
      fill="white"
    />
  </svg>
)

const UserSelect = () => {
  const { organization, settings } = useContext(OrganizationContext)
  const { t } = useTranslation()
  const [loggingOut, setLoggingOut] = useState(false)
  const [settingsModalIsOpen, setSettingsModalOpen] = useState(false)

  const logout = () => {
    if (loggingOut) return

    setLoggingOut(true)

    clearToken()

    API.logout()
      .then(() => {
        window.location.reload()
      })
      .catch(err => {
        setLoggingOut(false)
        console.error(err)
      })
  }

  console.log(settings)

  const openSettingsModal = () => {
    setSettingsModalOpen(true)
  }

  return (
    <div className="UserSelect">
      {organization && (
        <div className="UserSelectName">{organization.name}</div>
      )}
      {SETTINGS_MODAL_ENABLED && (
        <button className="UserSelectButton" onClick={openSettingsModal}>
          <SettingsIcon />
        </button>
      )}
      <button
        className="UserSelectButton"
        onClick={logout}
        disabled={loggingOut}>
        <LogoutIcon />
      </button>

      {settingsModalIsOpen && (
        <UserSettingsModal
          handleClose={() => setSettingsModalOpen(false)}
          langCode={settings.lang_preferences.language}
          country={settings.time_preferences.country}
          city={settings.time_preferences.city}
          available_languages={settings.available_languages}
          available_countries={settings.available_countries}
          available_timezones={settings.available_timezones}
        />
      )}
    </div>
  )
}

export default UserSelect
